module.exports = __webpack_public_path__ + "static/media/roble_weiss.3ea53f9c.jpg";